// Environment URL
// const environmentUrl = "https://org487f0635.crm8.dynamics.com";dev
const environmentUrl = "https://orgea61b289.crm8.dynamics.com";

const BAKERIES_TABLE = "cr3ea_prod_pqi_bakeries";
const FRONTS_TABLE = "cr3ea_prod_pqi_fronts";

/** Normalize bakeries record to fronts-like shape for summary logic */
function normalizeBakeriesRecord(item: any): any {
  if (!item) return item;
  const normalized = { ...item };
  if (item.cr3ea_status !== undefined) normalized.cr3ea_criteria = item.cr3ea_status;
  if (item.cr3ea_majordefect !== undefined) normalized.cr3ea_defectremarks = item.cr3ea_majordefect;
  if (item.cr3ea_itemno !== undefined) {
    normalized.cr3ea_evaluationtype = `Item ${item.cr3ea_itemno}`;
    normalized.cr3ea_packno = `Item ${item.cr3ea_itemno}`;
  }
  return normalized;
}

export type FetchSummaryDataOptions = { tableName?: string };

export async function fetchSummaryData(
  accessToken: string,
  qualityTourId: string,
  options?: FetchSummaryDataOptions
) {
  if (!accessToken || !qualityTourId) {
    console.error("Missing access token or quality tour ID");
    return null;
  }

  const apiVersion = "9.2";
  const tableName = options?.tableName === BAKERIES_TABLE ? BAKERIES_TABLE : FRONTS_TABLE;
  const isBakeries = tableName === BAKERIES_TABLE;

  // Bakeries table uses cr3ea_status, cr3ea_majordefect, cr3ea_itemno; fronts uses cr3ea_criteria, cr3ea_defectremarks, cr3ea_packno, cr3ea_evaluationtype
  const selectFields = isBakeries
    ? [
        'cr3ea_category',
        'cr3ea_cycle',
        'cr3ea_status',
        'cr3ea_defectcategory',
        'cr3ea_netweight',
        'cr3ea_itemno',
        'cr3ea_defect',
        'cr3ea_majordefect'
      ].join(',')
    : [
        'cr3ea_category',
        'cr3ea_cycle',
        'cr3ea_criteria',
        'cr3ea_defectcategory',
        'cr3ea_netweight',
        'cr3ea_packno',
        'cr3ea_evaluationtype',
        'cr3ea_defect',
        'cr3ea_defectremarks'
      ].join(',');

  const apiUrl = `${environmentUrl}/api/data/v${apiVersion}/${tableName}?$filter=cr3ea_qualitytourid eq '${qualityTourId}'&$select=${selectFields}`;

  console.log('fetchSummaryData: API URL:', apiUrl);

  const header = {
    Accept: "application/json",
    "Content-Type": "application/json; charset=utf-8",
    "OData-MaxVersion": "4.0",
    "OData-Version": "4.0",
    Authorization: `Bearer ${accessToken}`,
  };

  try {
    const response = await fetch(apiUrl, { 
      method: "GET",
      headers: header 
    });
    
    if (!response.ok) {
      throw new Error(`Error fetching data: ${response.statusText}`);
    }

    const responseData = await response.json();
    console.log("Fetched Summary Records - Total count:", responseData.value?.length || 0);
    console.log("Fetched Summary Records - Sample (first 3):", responseData.value?.slice(0, 3));
    
    // Log items with defects to see what we're getting
    const itemsWithDefects = (responseData.value || []).filter((item: any) => 
      item.cr3ea_defectcategory || item.cr3ea_criteria === 'Not Okay'
    );
    console.log("Fetched Summary Records - Items with defects:", itemsWithDefects.length);
    if (itemsWithDefects.length > 0) {
      console.log("Fetched Summary Records - Defect items sample:", itemsWithDefects.slice(0, 5));
    }

    if (!responseData.value || responseData.value.length === 0) {
      console.log("No summary data found for tour ID:", qualityTourId);
      return null;
    }

    const value = responseData.value;
    if (isBakeries && value.length > 0) {
      return value.map(normalizeBakeriesRecord);
    }
    return value;
  } catch (error) {
    console.error("Error loading summary data:", error);
    return null;
  }
} 